import { Contact, QuestionsAndAnswers } from "../types/HelpAndSupportDataTypes";
import helpandSupportIcons from "../assets/helpandSupportIcons/helpandSupportIcons.svg";
import orderQuantity from "../assets/helpandSupportIcons/orderQuantity.svg";
import deliveryTimeline from "../assets/helpandSupportIcons/deliveryTimeline.svg";
import deliveryBus from "../assets/helpandSupportIcons/delieveryBus.svg";
import timeLine from "../assets/helpandSupportIcons/timeLine.svg";
import orderReturn from "../assets/helpandSupportIcons/orderReturn.svg";
import wallet from "../assets/helpandSupportIcons/wallet.svg";
import sealed from "../assets/helpandSupportIcons/sealed.svg";

export const contactData: Contact[] = [
  {
    title: "CALL US AT",
    name: "Jane Doe",
    address: "4140 Parker Rd. Whitefield, Bangalore 560067",
    email: "partnerships@redrhino.co.in",
    phone: "+91-9036025879",
  },
];

export const FAQSData: QuestionsAndAnswers[] = [
  {
    image: helpandSupportIcons,
    question: "How do I place a keg order?",
    answer:
      "Orders can be placed through our online ordering system on this website. You'll need to create a business account first if you haven't already. Once logged in, select your desired beer and quantities and complete the payment. Once the payment is completed you will have access to view the current status of your order",
    note: "Note- A username and password link will be shared to you once you are onboarded in our system via the email your provided to us. Once this is done and your account is created, you can proceed to place an order.",
  },
  {
    image: orderQuantity,
    question: "What is the minimum order quantity?",
    answer:
      "We do not have a minimum order quantity. Please place your order as per your requirement.",
  },
  {
    image: deliveryTimeline,
    question: "What is the keg delivery timeline?",
    answer:
      "Orders placed before 3PM on the current day will be delivered by the next working day. Time of delivery cannot be committed as it is based on the vehicle route for that date. \n Orders placed post 3PM on the current day will be delivered on the following working day.",

    note: "Note- There will be no deliveries on public holidays or holidays declared by the excise department. Deliveries on second and fourth Saturdays will be confirmed by your sales representative.",
  },
  {
    image: deliveryBus,
    question: "Do you charge extra for delivery?",
    answer:
      "No, our per litre price which we quote includes all charges including delivery. ",
  },
  {
    image: timeLine,
    question: "How far in advance should I place my order?",
    answer:
      "We recommend placing orders at least 48 hours before your desired delivery date. For large orders (10+ kegs) or special events, please place your orders well in advance to ensure smooth operations.",
  },
  {
    image: orderReturn,
    question: "How do I return the empty kegs?",
    answer:
      "Empty kegs will be collected during your next delivery. If you do not have a pending delivery, you can reach out to your sales representative and inform them. The next available vehicle will be sent to pick up the empty kegs.",
  },
  {
    image: wallet,
    question: "How do I make the payment for the kegs order?",
    answer:
      "Payment for the kegs will be done through our online platform once the order has been placed and you proceed to the ‘payment’ stage. You will need to either upload a screenshot of the payment for the UTR number for us to further process the order. ",
  },
];

export const KeySpecifications: QuestionsAndAnswers[] = [
  {
    image: wallet,
    question: "What size kegs do you offer?",
    answer:
      "We currently offer standard 20L and 30L kegs for all our craft beer varieties. 50 L kegs are based on special requests and availability from time to time.",
  },
  {
    image: sealed,
    question: "What's the shelf life and how to store the kegs?",
    answer: [
      {
        category: "Storage",
        details: [
          "Ideal Storage: Dedicated Cold Room at 3–5 °C",
          "Alternative: Ambient temperature, away from sunlight",
        ],
      },
      {
        category: "Shelf Life",
        details: [
          "Unopened: 90 days from manufacture",
          "After Opening:",
          "Ambient Storage: Consume within 10 days",
          "Cold Room Storage: Consume within 30 days",
        ],
      },
    ],
  },
];
